/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export var TraceabilityEventInfo;
(function (TraceabilityEventInfo) {
    var eventType;
    (function (eventType) {
        eventType["EVENT_PROCESSED"] = "eventProcessed";
        eventType["EVENT_SKIPPED"] = "eventSkipped";
        eventType["EVENT_RETRIED"] = "eventRetried";
        eventType["BUSINESS_WARNING"] = "businessWarning";
    })(eventType = TraceabilityEventInfo.eventType || (TraceabilityEventInfo.eventType = {}));
})(TraceabilityEventInfo || (TraceabilityEventInfo = {}));
